import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import { clearCurrentProfile } from "../../actions/profileActions";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  WhatsappShareButton,
} from "react-share";
import { logoTitle } from "../../settings/headers/Header.utils";
const title =
  "Join us at #DevNector- A very cool social-network for developers";
//const size = "1.5rem";

class Navbar extends Component {
  onLogoutClick(e) {
    e.preventDefault();
    this.props.clearCurrentProfile();
    this.props.logoutUser();
  }

  render() {
    const { isAuthenticated, user } = this.props.auth;
    const { profiles } = this.props.profile;
    const url = "";
    const subject = `IciApart&Rooms, 
✅Add a mission for us to execute base on the general trend.
✅Explore available rooms and apartments found base on the trend of general request.
✔️Direct hel coaching session via team, zoom or google meeting on how to search an
apartment or room on spotahme platform 
#colocation #roomsforrent #apartmentforrent 
`;

    console.log("val_profiles", profiles);

    const authLinks = (
      <ul className="navbar-nav ml-auto">
        <p></p>
        <li className="nav-item">
          {/* <Link className="nav-link" to="/inspires">
            Inspire
          </Link> */}
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/about">
            About
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/hotfeeds">
            Hot Feeds
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/extrafeeds">
            extra Feeds
          </Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link" to="/feed">
            Rooms Feed
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/dashboard">
            Dashboard
          </Link>
        </li>

        <li className="nav-item">
          <a
            href="/"
            onClick={this.onLogoutClick.bind(this)}
            className="nav-link"
          >
            <img
              className="rounded-circle"
              src={user.avatar}
              alt={user.name}
              style={{ width: "25px", marginRight: "5px" }}
              title="You must have a Gravatar connected to your email to display an image"
            />{" "}
            Logout
          </a>
        </li>
      </ul>
    );

    const guestLinks = (
      <ul className="navbar-nav ml-auto">
       
        <li className="nav-item">
          <Link className="nav-link" to="/hotfeeds">
            Hot Feeds
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/register">
            Sign Up
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/login">
            Login
          </Link>
        </li>
      </ul>
    );

    return (
      <nav className="navbar navbar-expand-sm navbar-dark bg-dark mb-4 flex-wrap ">
        <div className="container">
          <Link className="navbar-brand" to="/">
            {logoTitle}
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#mobile-nav"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className="collapse navbar-collapse d-inline-flex "
            id="mobile-nav"
          >
            <ul className="navbar-nav mr-auto ">
              <li className="nav-item">
                <Link className="nav-link" to="/profiles">
                  {" "}
                  Tenants
                </Link>
              </li>

              <div className="bg-info rounded border-light">
                <WhatsappShareButton title={title} separator=":: " url={url}>
                  <i
                    className="bi bi-whatsapp d-block d-lg-none text-light bg-info ml-2 mr-1"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </WhatsappShareButton>

                <EmailShareButton
                  subject={subject}
                  body={title}
                  separator=":: "
                  url={url}
                >
                  <i
                    className="bi bi-envelope-fill bg-info text-light ml-lg-2 mr-1"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </EmailShareButton>
                <FacebookShareButton title={title} separator=":: " url={url}>
                  <i
                    className="bi bi-facebook  text-info bg-info text-light mr-1"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </FacebookShareButton>

                <LinkedinShareButton quote={title} separator=":: " url={url}>
                  <i
                    className="bi bi-linkedin  text-info bg-info text-light mr-1"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </LinkedinShareButton>
                <TwitterShareButton title={title} separator=":: " url={url}>
                  <i
                    className="bi bi-twitter  text-info bg-info text-light mr-2"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                </TwitterShareButton>
              </div>
            </ul>
            {isAuthenticated ? authLinks : guestLinks}
          </div>
        </div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(mapStateToProps, { logoutUser, clearCurrentProfile })(
  Navbar
);
